<script type="text/javascript">
  const TYPE_MIDDLE = 1;

  export default {
    name: 'draggable-point',
    template: `<div
  @mousedown="mousedown"
  @dblclick="dblclick"
  :style="style"
  class="wall-point"
  ></div>`,
    props: {
      top: Number,
      left: Number,
      type: Number,
      insertPos: Number,
      lineIndex: Number,
      id: [String, Number],
    },
    methods: {
      dblclick(e) {
        this.$emit('remove', {
          id: this.id,
          type: this.type,
          insertPos: this.insertPos || null,
          event: e,
          offsetX: e.clientX - this.$el.offsetLeft,
          offsetY: e.clientY - this.$el.offsetTop,
          x: this.left,
          y: this.top,
          lineIndex: this.lineIndex,
        });
      },
      mousedown(e) {
        this.$emit('mousedown', {
          id: this.id,
          type: this.type,
          insertPos: this.insertPos || null,
          event: e,
          offsetX: e.clientX - this.$el.offsetLeft,
          offsetY: e.clientY - this.$el.offsetTop,
          x: this.left,
          y: this.top,
        });
      },
    },
    computed: {
      style() {
        return {
          background: `${this.type === TYPE_MIDDLE ? '#F4F5F6' : '#88929D'}`,
          position: 'absolute',
          top: `${this.top}px`,
          left: `${this.left}px`,
        };
      },
    },
    data() {
      return {
      };
    },
  };
</script>


// WEBPACK FOOTER //
// DraggablePoint.vue?05afd209